import { Icon } from 'components/icon'
import { SwitchCustom } from 'components/switch'
import { Typography } from 'components/typography'
import { TypographyTypes } from 'interfaces'
import React, { FC } from 'react'

interface SetUpInfoTabProps {
	title: string
	subTitle: string
	icon: string
	value: boolean
	disabled?: boolean
	setValue?: (value: boolean) => void
}

export const SetUpInfoTab: FC<SetUpInfoTabProps> = (props): JSX.Element => {
	const { title, subTitle, icon, value, disabled, setValue } = props
	return (
		<div className="w-full pt-4">
			<div>
				<Typography
					title={title}
					fontLeading="12/15"
					type={TypographyTypes.h2}
					className="text-gray-16"
				/>
			</div>
			<div className="flex justify-between items-center">
				<div className="flex flex-row items-center">
					<Icon src={icon} className="w-[24px] py-2 mr-2" fillPath />
					<Typography
						title={subTitle}
						fontLeading="15/22"
						type={TypographyTypes.h3}
						className="text-gray-16"
					/>
				</div>
				<div>
					{setValue && (
						<SwitchCustom
							enabled={value}
							setEnabled={stateSwitch => setValue(stateSwitch as boolean)}
							className={!value ? '!bg-gray-2' : ''}
							disabled={disabled}
						/>
					)}
				</div>
			</div>
		</div>
	)
}

SetUpInfoTab.defaultProps = {
	disabled: undefined,
	setValue: undefined
}
